import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';


export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col bg-dark-50">
      <Navbar />
      
      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center py-40 px-4">
        <div className="max-w-2xl w-full text-center">
          <div className="bg-dark-100 border border-white/10 rounded-2xl p-8 md:p-12 shadow-xl">
            <div className="mb-8">
              <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">404</h1>
              <h2 className="text-2xl md:text-3xl font-display font-bold text-white mb-6">Page Not Found</h2>
              <p className="text-lg text-neutral-400 mb-8">
                The page you are looking for could not be found. It may have been moved, deleted, or the URL might be incorrect.
              </p>
            </div>
            
            <div className="flex flex-col sm:flex-row justify-center gap-4">
              <Link 
                to="/" 
                className="btn btn-primary px-8 py-3 text-base font-medium rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-primary-500/30"
              >
                <span className="relative z-10">Back to Home</span>
              </Link>
              
              <button 
                onClick={() => window.history.back()} 
                className="btn btn-secondary px-8 py-3 text-base font-medium rounded-xl transition-all duration-300 hover:shadow-lg hover:shadow-secondary-500/30"
              >
                <span className="relative z-10">Go Back</span>
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}